// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecordsTable_wrapper___vT29"};